import axiosInstance from '../../../api/axiosConfig';
import { AddAdNetwork, AdNetwork } from '../../../types/ad-network';

export const getAdNetworks = async () => {
    const response = await axiosInstance.get<AdNetwork[]>('/ad-network');
    return response?.data;
};

export const createAdNetwork = async (adNetwork: AddAdNetwork) => {
    const response = await axiosInstance.post<AdNetwork>('/ad-network', adNetwork);
    return response?.data;
};

export const updateAdNetwork = async (adNetwork: AdNetwork) => {
    const response = await axiosInstance.patch<AdNetwork>(`/ad-network/${adNetwork.id}`, adNetwork);
    return response?.data;
};
